import { detectCountry } from "./emergencyData";

export const TABS = [
  { id: "admin",  label: "Administratif & Vital", shortLabel: "Admin",  icon: "📁" },
  { id: "valise", label: "Dans ma Valise",         shortLabel: "Valise", icon: "🧳" },
  { id: "tech",   label: "Matériel & Tech",        shortLabel: "Tech",   icon: "🔌" },
];

const DEFAULT_ITEMS = {
  admin: [
    { id: "d_passeport",   text: "Passeport valide" },
    { id: "d_billet",      text: "Billets d'avion (imprimés ou PDF)" },
    { id: "d_assurance",   text: "Attestation d'assurance voyage" },
    { id: "d_carte_vitale", text: "Carte Vitale / CEAM" },
    { id: "d_visa",        text: "Visa (si requis)" },
    { id: "d_copies",      text: "Photocopies de tous les documents" },
    { id: "d_urgences",    text: "Numéros d'urgence locaux notés" },
  ],
  valise: [
    { id: "d_pharma",       text: "Trousse à pharmacie", note: "Antidouleurs, antihistaminiques, pansements, sérum physiologique" },
    { id: "d_chaussures",   text: "Chaussures de marche confortables" },
    { id: "d_chapeau",      text: "Chapeau / casquette" },
    { id: "d_lunettes",     text: "Lunettes de soleil" },
    { id: "d_creme",        text: "Crème solaire" },
    { id: "d_hydratant",    text: "Crème hydratante" },
    { id: "d_hygiene",      text: "Nécessaire d'hygiène complet" },
    { id: "d_adaptateur",   text: "Adaptateur secteur universel" },
  ],
  tech: [
    { id: "d_powerbank",  text: "Batterie externe (powerbank)", note: "Minimum 10 000 mAh recommandé" },
    { id: "d_ecouteurs",  text: "Écouteurs / casque" },
    { id: "d_chargeurs",  text: "Chargeurs (téléphone, montre, tablette...)" },
    { id: "d_cable",      text: "Câble universel (USB-C / Lightning)" },
    { id: "d_antivol",    text: "Cadenas ou antivol de sac" },
  ],
};

const COUNTRY_ITEMS = {
  NAMIBIA: {
    admin: [
      { id: "c_nb_permis",       text: "Permis de conduire international" },
      { id: "c_nb_assurance4x4", text: "Preuve d'assurance 4x4" },
    ],
    valise: [
      { id: "c_nb_pull",  text: "Gros pull / Polaire chaude", note: "💡 Le conseil de Diego : Ne te fais pas avoir comme moi ! Dans le désert et le sud namibien, les nuits frôlent les 0°C. Prends un vrai vêtement chaud." },
    ],
    tech: [
      { id: "c_nb_frontale",   text: "Lampe frontale", note: "Indispensable pour le camping ou les coupures de courant" },
      { id: "c_nb_manometre",  text: "Manomètre pour pneus" },
    ],
  },
  SOUTH_AFRICA: {
    admin: [
      { id: "c_za_permis", text: "Permis de conduire international" },
    ],
    valise: [
      { id: "c_za_chaud", text: "Vêtement chaud (soirées fraîches)", note: "💡 Le conseil de Diego : Les soirées au Cap et dans les winelands peuvent surprendre." },
    ],
    tech: [
      { id: "c_za_frontale", text: "Lampe frontale (parcs naturels)", note: "Utile dans les lodges et safaris" },
    ],
  },
  BOTSWANA: {
    admin: [
      { id: "c_bw_permis",  text: "Permis de conduire international" },
      { id: "c_bw_vaccin",  text: "Carnet de vaccination (fièvre jaune si transit)" },
    ],
    valise: [
      { id: "c_bw_chaud",       text: "Vêtements chauds pour les nuits de brousse", note: "💡 Le conseil de Diego : Dans le delta de l'Okavango, les températures nocturnes chutent brutalement." },
      { id: "c_bw_imperméable", text: "Imperméable léger" },
    ],
    tech: [
      { id: "c_bw_frontale", text: "Lampe frontale", note: "Indispensable en lodge ou camping" },
    ],
  },
  MAURITIUS: {
    admin: [
      { id: "c_mu_allinone", text: "Formulaire All-in-One mauricien" },
      { id: "c_mu_hotel",    text: "Copie de la réservation d'hôtel" },
    ],
    valise: [
      { id: "c_mu_chaussures_eau", text: "Chaussures d'eau / de récif", note: "💡 Le conseil de Diego : Indispensable pour marcher sur les coraux et éviter les poissons-pierres." },
      { id: "c_mu_creme_eco",      text: "Crème solaire éco-responsable", note: "Pour préserver les coraux de l'île." },
    ],
    tech: [],
  },
  REUNION: {
    admin: [
      { id: "c_re_cni", text: "CNI française (DOM — pas de passeport requis)" },
    ],
    valise: [
      { id: "c_re_chaussures", text: "Chaussures d'eau / de récif", note: "💡 Le conseil de Diego : Idéal pour explorer les lagons et les cascades." },
      { id: "c_re_imperméable", text: "Imperméable (côté au vent très pluvieux)" },
    ],
    tech: [],
  },
  MADAGASCAR: {
    admin: [
      { id: "c_mg_visa",   text: "Visa touristique (à vérifier avant départ)" },
      { id: "c_mg_vaccin", text: "Carnet de vaccination (paludisme, hépatites)" },
    ],
    valise: [
      { id: "c_mg_antimoustiques", text: "Répulsif anti-moustiques fort (DEET)" },
      { id: "c_mg_antipaludeen",   text: "Traitement antipaludéen (à prescrire avant le départ)" },
    ],
    tech: [
      { id: "c_mg_frontale",  text: "Lampe frontale (coupures de courant fréquentes)" },
    ],
  },
  JAPAN: {
    admin: [
      { id: "c_jp_jrpass", text: "JR Pass commandé à l'avance (si multi-villes)" },
      { id: "c_jp_suica",  text: "Informations sur la carte IC (Suica)" },
    ],
    valise: [
      { id: "c_jp_couvrant", text: "Vêtements couvrants pour temples et onsen", note: "💡 Le conseil de Diego : Bras et épaules couverts obligatoires dans de nombreux temples." },
    ],
    tech: [
      { id: "c_jp_esim",  text: "Pocket WiFi ou e-SIM Japon réservé" },
      { id: "c_jp_maps",  text: "Maps hors-ligne Tokyo/Osaka téléchargées" },
    ],
  },
  THAILAND: {
    admin: [
      { id: "c_th_vaccin", text: "Vaccins recommandés (hépatite A, typhoïde)" },
    ],
    valise: [
      { id: "c_th_antimoustiques", text: "Répulsif anti-moustiques" },
      { id: "c_th_temple",         text: "Tenue couvrant épaules et genoux (temples)", note: "💡 Le conseil de Diego : Un paréo léger dans le sac, ça sauve la mise à l'entrée des temples." },
    ],
    tech: [
      { id: "c_th_sim", text: "SIM thaïlandaise (AIS / dTac) ou e-SIM" },
    ],
  },
  MOROCCO: {
    admin: [
      { id: "c_ma_copies", text: "Copies papier du passeport" },
    ],
    valise: [
      { id: "c_ma_couvrant", text: "Vêtements couvrants (médinas & mosquées)", note: "💡 Le conseil de Diego : Respecter les coutumes locales, surtout en dehors des zones touristiques." },
      { id: "c_ma_chaud",    text: "Vêtement chaud pour les nuits du désert", note: "💡 Le conseil de Diego : Dans le Sahara, même en été, il peut faire 5°C la nuit." },
    ],
    tech: [],
  },
  INDONESIA: {
    admin: [
      { id: "c_id_vaccin", text: "Vaccins recommandés (hépatite A, typhoïde)" },
    ],
    valise: [
      { id: "c_id_antimoustiques", text: "Répulsif anti-moustiques (dengue présente)" },
      { id: "c_id_sarong",         text: "Sarong / vêtement couvrant (temples balinais)", note: "💡 Le conseil de Diego : Fourni sur place mais emporter le sien pour le confort." },
    ],
    tech: [
      { id: "c_id_sim", text: "SIM locale (Telkomsel) ou e-SIM Bali" },
    ],
  },
  VIETNAM: {
    admin: [
      { id: "c_vn_evisa", text: "e-Visa Vietnam (obligatoire, à anticiper)" },
    ],
    valise: [
      { id: "c_vn_antimoustiques", text: "Répulsif anti-moustiques" },
      { id: "c_vn_couvrant",       text: "Vêtements couvrants (pagodes, campagne)" },
    ],
    tech: [
      { id: "c_vn_sim", text: "SIM vietnamienne (Viettel) ou e-SIM" },
    ],
  },
};

export function getItemsForDestination(destination = "") {
  const country = detectCountry(destination);
  const extra = COUNTRY_ITEMS[country] || {};
  return {
    admin:  [...DEFAULT_ITEMS.admin,  ...(extra.admin  || [])],
    valise: [...DEFAULT_ITEMS.valise, ...(extra.valise || [])],
    tech:   [...DEFAULT_ITEMS.tech,   ...(extra.tech   || [])],
    country,
  };
}
